import { render, staticRenderFns } from "./CompArticlesIdea.vue?vue&type=template&id=7734110b"
import script from "./CompArticlesIdea.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticlesIdea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports